import React from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section id="bonos" className="relative z-10 py-16 md:py-24 px-4 cosmic-bg" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        {/* Section Header */}
        <div className="text-center mb-10" data-id="element-19">
          <div className="inline-flex items-center gap-2 bg-green-500/20 border border-green-500/40 rounded-full px-6 py-2 mb-6" data-id="element-20">
            <GiftIcon className="w-5 h-5 text-green-400" data-id="element-21" />
            <span className="text-green-400 font-bold uppercase tracking-wider" data-id="element-22">
              ¡GRATIS por el día de hoy!
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4" data-id="element-23">
            Además, llevás estos{' '}
            <span className="text-gold-gradient" data-id="element-24">BONOS EXCLUSIVOS</span>
          </h2>
          <p className="text-xl text-white/80" data-id="element-25">
            Incluidos sin costo adicional con tu compra de hoy
          </p>
        </div>

        {/* Bonus Cards - Horizontal Layout */}
        <div className="space-y-5" data-id="element-26">
          {/* Bonus 1 */}
          <a href="#comprar" className="group flex flex-row items-center gap-4 md:gap-6 bg-[#1a1030] border border-[#F5C842]/20 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#F5C842]/50 hover:shadow-lg hover:shadow-[#F5C842]/10 p-3 md:p-4" data-id="element-27">
            <div className="relative flex-shrink-0 w-28 md:w-36" data-id="element-28">
              <div className="absolute top-1 left-1 z-10 bg-green-500 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-29">
                GRATIS
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/gbgQ8QT2Bmbh4BzMbTK6N6/BONO_1_NATAl.png" alt="Bonus 1 - Diseño WOW para tus Cartas Natales" className="w-full h-auto rounded-lg transition-transform duration-300 group-hover:scale-105" data-id="element-30" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-31">
              <span className="text-sm font-bold text-[#F5C842] uppercase tracking-wider" data-id="element-32">
                BONUS #1
              </span>
              <h3 className="text-base md:text-lg font-bold text-white mt-1 mb-1" data-id="element-33">
                Pack Premium: Plantillas de informes
              </h3>
              <p className="text-white/70 text-sm leading-relaxed" data-id="element-34">
                Pack de plantillas premium: 10 portadas editables, 5 estilos de
                informes interiores, paletas de color profesionales.
              </p>
            </div>
          </a>

          {/* Bonus 2 */}
          <a href="#comprar" className="group flex flex-row items-center gap-4 md:gap-6 bg-[#1a1030] border border-[#F5C842]/20 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#F5C842]/50 hover:shadow-lg hover:shadow-[#F5C842]/10 p-3 md:p-4" data-id="element-35">
            <div className="relative flex-shrink-0 w-28 md:w-36" data-id="element-36">
              <div className="absolute top-1 left-1 z-10 bg-green-500 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-37">
                GRATIS
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/dJzdnoKS7MSW4qkHneVhGZ/BONO_2_NATAL.png" alt="Bonus 2 - Biblioteca de Interpretaciones Inteligentes" className="w-full h-auto rounded-lg transition-transform duration-300 group-hover:scale-105" data-id="element-38" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-39">
              <span className="text-sm font-bold text-[#F5C842] uppercase tracking-wider" data-id="element-40">
                BONUS #2
              </span>
              <h3 className="text-base md:text-lg font-bold text-white mt-1 mb-1" data-id="element-41">
                Biblioteca de Interpretaciones Inteligentes
              </h3>
              <p className="text-white/70 text-sm leading-relaxed" data-id="element-42">
                25 textos listos para entregar interpretaciones: redacción
                cálida y profesional, listas para personalizar rápido,
                estructura que suena humana.
              </p>
            </div>
          </a>

          {/* Bonus 3 */}
          <a href="#comprar" className="group flex flex-row items-center gap-4 md:gap-6 bg-[#1a1030] border border-[#F5C842]/20 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#F5C842]/50 hover:shadow-lg hover:shadow-[#F5C842]/10 p-3 md:p-4" data-id="element-43">
            <div className="relative flex-shrink-0 w-28 md:w-36" data-id="element-44">
              <div className="absolute top-1 left-1 z-10 bg-green-500 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-45">
                GRATIS
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/n5k5JSrU6UKAcBrbTccyxK/BONO_3_NATAL.png" alt="Bonus 3 - Ingresos Recurrentes Astrológicos" className="w-full h-auto rounded-lg transition-transform duration-300 group-hover:scale-105" data-id="element-46" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-47">
              <span className="text-sm font-bold text-[#F5C842] uppercase tracking-wider" data-id="element-48">
                BONUS #3
              </span>
              <h3 className="text-base md:text-lg font-bold text-white mt-1 mb-1" data-id="element-49">
                Ingresos Recurrentes Astrológicos
              </h3>
              <p className="text-white/70 text-sm leading-relaxed" data-id="element-50">
                Kit de lecturas predictivas para fidelizar clientas:
                predicciones mensuales listas para entregar y generar ingresos
                recurrentes.
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}